import { useState, useEffect } from 'react';

interface Config {
  stockLength: number;
  bladeWidth: number;
  minCutLength: number;
  useRemnants: boolean;
}

const DEFAULT_CONFIG: Config = {
  stockLength: 290, // 290 inches
  bladeWidth: 0.125, // 1/8 inch blade width
  minCutLength: 6, // 6 inch minimum cut length
  useRemnants: true, // Use remnants by default
};

export function useConfig() {
  const [config, setConfig] = useState<Config>(() => {
    // Try to load from localStorage
    const savedConfig = localStorage.getItem('metalFabConfig');
    return savedConfig ? JSON.parse(savedConfig) : DEFAULT_CONFIG;
  });

  // Save to localStorage whenever config changes
  useEffect(() => {
    localStorage.setItem('metalFabConfig', JSON.stringify(config));
  }, [config]);

  const updateConfig = (newConfig: Partial<Config>) => {
    setConfig(prev => ({ ...prev, ...newConfig }));
  };

  const resetConfig = () => {
    setConfig(DEFAULT_CONFIG);
  };

  return { config, updateConfig, resetConfig };
}
